import React, { useState } from "react"
// import SearchAccordion from "../../../SearchAccordion/SearchAccordion";

import SearchIcon from "../../../../Assets/svg/search-grey.svg"
import mobileSearchStyles from "./MobileSearch.module.css"

const MobileSearch = () => {
  // const [showSearchAccordion, setShowSearchAccordion] = useState(false);

  const handleSearchClick = () => {
    // !showSearchAccordion && setShowSearchAccordion(true)
    window.location.href = process.env.RAZZLE_APP_BASE_URL + "/search";
  }

  return (
    <>
      <div className={mobileSearchStyles.inputbAR}>
        <img src={SearchIcon} className={mobileSearchStyles.searchIcon} />
        <input
          type="button"
          onClick={handleSearchClick}
          defaultValue="Search Tests, Package, Body Areas.."
        />
      </div>
      {/* {showSearchAccordion
        ? <SearchAccordion setShowSearchAccordion={setShowSearchAccordion} />
        : null
      } */}
    </>
  )
}

export default MobileSearch;